import _defineProperty from "/codebuild/output/src3403646861/src/bluewaveenergy-web-gatsby-react/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/codebuild/output/src3403646861/src/bluewaveenergy-web-gatsby-react/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["bsPrefix", "className", "striped", "bordered", "borderless", "hover", "size", "variant", "responsive"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import classNames from 'classnames';
import * as React from 'react';
import { useBootstrapPrefix } from './ThemeProvider';
import { jsx as _jsx } from "react/jsx-runtime";
var Table = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var bsPrefix = _ref.bsPrefix,
    className = _ref.className,
    striped = _ref.striped,
    bordered = _ref.bordered,
    borderless = _ref.borderless,
    hover = _ref.hover,
    size = _ref.size,
    variant = _ref.variant,
    responsive = _ref.responsive,
    props = _objectWithoutProperties(_ref, _excluded);
  var decoratedBsPrefix = useBootstrapPrefix(bsPrefix, 'table');
  var classes = classNames(className, decoratedBsPrefix, variant && "".concat(decoratedBsPrefix, "-").concat(variant), size && "".concat(decoratedBsPrefix, "-").concat(size), striped && "".concat(decoratedBsPrefix, "-").concat(typeof striped === 'string' ? "striped-".concat(striped) : 'striped'), bordered && "".concat(decoratedBsPrefix, "-bordered"), borderless && "".concat(decoratedBsPrefix, "-borderless"), hover && "".concat(decoratedBsPrefix, "-hover"));
  var table = /*#__PURE__*/_jsx("table", _objectSpread(_objectSpread({}, props), {}, {
    className: classes,
    ref: ref
  }));
  if (responsive) {
    var responsiveClass = "".concat(decoratedBsPrefix, "-responsive");
    if (typeof responsive === 'string') {
      responsiveClass = "".concat(responsiveClass, "-").concat(responsive);
    }
    return /*#__PURE__*/_jsx("div", {
      className: responsiveClass,
      children: table
    });
  }
  return table;
});
export default Table;